import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"height":"100%","background-color":"white"}
}
const _hoisted_2 = { class: "info-background" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_information_header = _resolveComponent("information-header")!
  const _component_information_info_block = _resolveComponent("information-info-block")!
  const _component_information_main_function_block = _resolveComponent("information-main-function-block")!
  const _component_information_document_block = _resolveComponent("information-document-block")!
  const _component_information_footer = _resolveComponent("information-footer")!
  const _component_q_no_ssr = _resolveComponent("q-no-ssr")!

  return (_openBlock(), _createBlock(_component_q_no_ssr, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_information_header),
          _createVNode(_component_information_info_block)
        ]),
        _createVNode(_component_information_main_function_block),
        _createVNode(_component_information_document_block),
        _createVNode(_component_information_footer)
      ])
    ]),
    _: 1
  }))
}